import * as React from 'react';
// import Accordion from '@mui/material/Accordion';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import Typography from '@mui/material/Typography';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {  Typography } from '@mui/material';

const DetailsAccordion = (props) => {

    

    return (
        <div >
            <Typography variant='h4'>Bank Account Detail-FIA Technology Service Pvt. Ltd. </Typography>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 1200 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Bank Name</TableCell>
                                    <TableCell align="left">Account Number</TableCell>
                                    <TableCell align="left">Branch</TableCell>
                                    <TableCell align="left">Account Name</TableCell>
                                    <TableCell align="left">Ifsc Code</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.rows&&props.rows.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell sx={{fontSize:'13px'}} component="th" scope="row">
                                            {row.bank_name}
                                        </TableCell>
                                        <TableCell sx={{fontSize:'13px'}} align="left">{row.account_no}</TableCell>
                                        <TableCell sx={{fontSize:'13px'}} align="left">{row.branch}</TableCell>
                                        <TableCell sx={{fontSize:'13px'}} align="left">{row.account_name}</TableCell>
                                        <TableCell sx={{fontSize:'13px'}} align="left">{row.ifsc_code}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                
            {/* <Accordion sx={{ backgroundColor: 'whitesmoke' }}>
                <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography sx={{fontWeight:'600'}}>Time Table for fund transfer</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{overflowX:'scroll',scrollbarWidth:'none'}}>
                <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 1200 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Request Recieving Time in Panel</TableCell>
                                    <TableCell align="center">Previous day pending and up to 9:30 AM</TableCell>
                                    <TableCell align="center">After 9:30 AM and up to 10:30 PM</TableCell>
                                    <TableCell align="center">After 10:30 AM and up to 12:30 PM</TableCell>
                                    <TableCell align="center">After 12:30 PM and up to 02:30 PM</TableCell>
                                    <TableCell align="center">After 02:30 PM and up to 04:30 PM</TableCell>
                                    <TableCell align="center">After 04:30 PM and up to 06:30 PM</TableCell>
                                    <TableCell align="center">After 06:30 PM and after</TableCell>


                                </TableRow>
                            </TableHead>
                            <TableBody>
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                       <TableCell>We will transfer by</TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center">By 01:00 PM</TableCell>
                                    <TableCell align="center">By 03:00 PM</TableCell>
                                    <TableCell align="center">By 05:00 PM</TableCell>
                                    <TableCell align="center">By 06:30 PM</TableCell>
                                    <TableCell align="center">Next Working Day</TableCell>
                                    </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion> */}
        </div>
    );
}

export default DetailsAccordion;
